"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prefer-destructuring */
const core_1 = require("@angular/core");
const customer_1 = require("../../customer/customer");
const toast_service_1 = require("../../../../../../ui-components/toast/toast.service");
const opportunity_1 = require("../opportunity");
let OpportunityEmailSendingForm = class OpportunityEmailSendingForm {
    constructor(customerModel, opportunityModel, toastService) {
        this.customerModel = customerModel;
        this.opportunityModel = opportunityModel;
        this.toastService = toastService;
        this.customer = null;
        this.sending = false;
        this.emailRequest = {
            body: '',
            subject: '',
            opportunityId: '',
            email: '',
        };
        this.sendEmail = () => __awaiter(this, void 0, void 0, function* () {
            this.sending = true;
            // ! We disabled this for now, since the formatting seems odd.
            // Add "<" to every line if a message to quote is provided
            // if (this.quoteText) {
            // eslint-disable-next-line max-len
            //   const quote = `Ursprüngliche Nachricht: \n---------------------------------------------- \n${this.quoteText}`
            //     .split('\n')
            //     .map((line) => `< ${line}`)
            //     .join('\n');
            //   this.emailRequest.body = `${this.emailRequest.body}\n\n${quote}`;
            // }
            yield this.opportunityModel.sendEmail(this.emailRequest);
            this.toastService.toast(toast_service_1.ToastType.SUCCESS, 'E-Mail an Kunden gesendet');
            this.exit();
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.emailRequest.opportunityId = this.opportunity.id;
            this.customer = yield this.customerModel.get(this.opportunity.customerId);
            this.emailRequest.email = this.customer.email;
            if (this.emailSubject)
                this.emailRequest.subject = this.emailSubject;
        });
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], OpportunityEmailSendingForm.prototype, "opportunity", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Function)
], OpportunityEmailSendingForm.prototype, "exit", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], OpportunityEmailSendingForm.prototype, "quoteText", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], OpportunityEmailSendingForm.prototype, "emailSubject", void 0);
OpportunityEmailSendingForm = __decorate([
    (0, core_1.Component)({
        selector: 'opportunity-email-form',
        templateUrl: require('./email-sending.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof customer_1.CustomerModel !== "undefined" && customer_1.CustomerModel) === "function" ? _a : Object, typeof (_b = typeof opportunity_1.OpportunityModel !== "undefined" && opportunity_1.OpportunityModel) === "function" ? _b : Object, typeof (_c = typeof toast_service_1.ToastService !== "undefined" && toast_service_1.ToastService) === "function" ? _c : Object])
], OpportunityEmailSendingForm);
exports.default = OpportunityEmailSendingForm;
